module.exports = __webpack_public_path__ + "static/media/otherdark.ee4eace1.svg";